module.exports = __webpack_public_path__ + "img/tosano-mobile.0029f3eb.svg";